import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";

import Button from "react-bootstrap/Button";



import MailBoxIcon from "../images/mail-box-icon.svg";

import ValidationAlertIcon from "../images/validation-alert-icon.svg";
import WelcomeToGitchaMoboffcanvas from "../components/WelcomeToGitchaMoboffcanvas";
const CheckYourEmail = (props) => {
 
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div className="mobile-wrapper bg-grey-variant">

      <div className="mobile-wrapper-inner bg-grey-variant">
      
      <div className="signup-login-header clearfix">
        <div className="signup-login-header-top clearfix">
          <a className="back-link" href="#">Back</a>
          <span>Step 1 of 2</span> 

        </div>
        
         
          
        </div>

        <div className="check-mail-wrap text-center">
        <img className="mb-3" src={MailBoxIcon} />
        <h2>Check your email</h2>
        <p>We’ve sent a login link to johnsmith@gmail.com.</p>
        <Button variant="primary" className="btn w-100 mb-3">Open Email App</Button>

        <div className="resend-timer">Resend <span>59</span> sec</div>
        <button type="button" className="btn btn-no-bg p-0" onClick={handleShow} >Didn't get an email? Let's resend it</button>
        
        
        <WelcomeToGitchaMoboffcanvas
         
         show={show}
      onHide={handleClose}
      />
       
       


        </div>






        

        

        

        

        
        
        
        
        
                       
        
      </div>
    </div>
  );
};

export default CheckYourEmail;
